<template>
  <div v-if="ctaConfig" class="search-discover-cta">
    <ys-text
      v-if="showDescription"
      type="body1"
      class="cta-description"
      data-test="search-discover-cta-description"
    >
      {{ ctaConfig.description }}
    </ys-text>
    <ys-button
      variant="secondary"
      size="small"
      width="inline"
      data-test="search-discover-cta-button"
      @click="handleClick"
    >
      <x-icon
        slot="icon"
        :icon="ctaConfig.icon"
        width="16px"
        height="16px"
        color="currentColor"
      />
      {{ ctaConfig.buttonLabel }}
    </ys-button>
  </div>
</template>

<script setup lang="ts">
import fishRoutes from '@/fish/router/constants'

import { queryInput, setSearchIsActive } from '@/services/search-service'
import marketingEventService from '@/services/marketing-event-service'
import { Vertical } from '@/types/verticals'
import '@onxmaps/yellowstone-ui/ys-button'
import '@onxmaps/yellowstone-ui/ys-text'
import xIcon from '@/components/shared/x-icon/index.vue'
import { computed } from 'vue'
import { useRouter } from 'vue-router'

interface SearchDiscoverCtaProps {
  showDescription?: boolean
}
const { showDescription = false } = defineProps<SearchDiscoverCtaProps>()

const router = useRouter()

type SearchDiscoverCtaConfig = {
  app: Vertical
  buttonLabel: string
  icon: string
  description: string
  route: string
}

const SearchDiscoverByApp: SearchDiscoverCtaConfig[] = [
  {
    app: Vertical.Fish,
    buttonLabel: 'Discover Nearby Lakes',
    icon: 'waypoint-type/largemouth-bass',
    description: 'Explore lakes by species, abundance and trophy potential',
    route: fishRoutes.WATERBODIES,
  },
]

const ctaConfig = computed(() =>
  SearchDiscoverByApp.find((config) => config.app === 'fish')
)

const trimmedSearchQuery = computed(() => queryInput.value?.trim())

const handleClick = () => {
  // Close search UI
  setSearchIsActive(false)

  // Send marketing event
  marketingEventService.publish('search_discover_cta_clicked', {
    search_state: trimmedSearchQuery.value?.length
      ? 'no results found'
      : 'empty state',
    query: trimmedSearchQuery.value,
  })

  // Navigate to Discover route
  router
    .push({ name: ctaConfig.value?.route, query: { origin: 'search' } })
    .catch(() => {})
}
</script>

<style scoped lang="scss">
.search-discover-cta {
  text-align: center;
}

.cta-description {
  max-width: 290px;
  margin-bottom: var(--ys-spacing-250);
  color: var(--ys-color-text-secondary);
}
</style>
